import { render, staticRenderFns } from "./XmlMatches.vue?vue&type=template&id=58112e40&"
import script from "./XmlMatches.vue?vue&type=script&lang=js&"
export * from "./XmlMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports